(() => {
  if (!window.ResizeObserver) return;

  document.querySelectorAll('product-gallery.product-gallery--desktop-thumbnails-left').forEach((gallery) => {
    const arWrapper = gallery.querySelector('.product-gallery__ar-wrapper');
    const thumbnailList = gallery.querySelector('.product-gallery__thumbnail-list');

    if (!arWrapper || !thumbnailList) return;

    const desktopQuery = window.matchMedia('(min-width: 1150px)');

    const syncHeight = () => {
      thumbnailList.style.height = desktopQuery.matches ? `${arWrapper.offsetHeight}px` : '';
    };

    new ResizeObserver(syncHeight).observe(arWrapper);
    desktopQuery.addEventListener('change', syncHeight);
  });
})();
